// src/pages/Biblioteca.js

import React, { useEffect, useRef } from 'react';
import { FiBookOpen } from 'react-icons/fi';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { motion, useScroll, useTransform } from 'framer-motion';

import '../styles/Biblioteca.css';
import portadaImg from '../assets/images/portada.webp';

const Biblioteca = () => {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end start"]
  });
  const parallaxY = useTransform(scrollYProgress, [0, 1], ["0%", "20%"]);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: 'ease-in-out',
    });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="biblioteca-page-container" ref={containerRef}>
      <motion.div
        className="biblioteca-background-image"
        style={{
          backgroundImage: `url(${portadaImg})`,
          y: parallaxY
        }}
      />
      <div className="container-biblioteca" data-aos="fade-up">
        <div className="construction-content">
          <div className="construction-icon-wrapper">
            <FiBookOpen className="construction-icon" />
          </div>
          <h1 className="construction-title">Biblioteca Digital de Recursos</h1>
          <p className="construction-subtitle">Sección en Construcción</p>
          <p className="construction-description">
            Estamos compilando y organizando un completo archivo de documentos, guías legales, 
            publicaciones especializadas y material de congresos para potenciar la gestión en el sector salud.
            ¡Vuelve pronto para acceder a estos valiosos recursos!
          </p>
        </div>
      </div>
    </div>
  );
};

export default Biblioteca;